<template>
  <div class="side-catalogue-container">
    <div class="help">
      <div style="margin-bottom: 14px">
        {{ texts?.articleDetail.hasHelp.title }}
      </div>
      <div class="help-box">
        <div
          v-for="(item, index) in texts.articleDetail.hasHelp.options"
          class="help-item"
          :class="{ 'is-active': selectedHelp === item }"
          :key="index"
          @click="onHelpClick(item)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <ul>
      <!-- <div
        v-if="catalogueList.length > 0 && currentIndex !== -1"
        class="dot"
        :style="{ top: 12 + (currentIndex ? currentIndex : 0) * 30 + 'px' }"
      ></div> -->
      <li
        v-for="(item) in catalogueList"
        :key="item.id"
        :type="item.type"
        @click="handleClickLi(item.id)"
        :class="{ active: currentCataDomId === item.id }"
        :title="item.text"
      >
        {{ item.order + item.text }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { updateThumbsupNum } from "../../api/blog"

export default {
  props: {
    catalogueList: {
      default: () => [],
      require: true,
      type: Array,
    },
    currentCataDomId: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      selectedHelp: null,
    }
  },
  computed: {
    ...mapState(["currentBlogId", "texts"]),
    currentIndex() {
      return this.catalogueList.findIndex(
        (item) => item.id === this.currentCataDomId
      )
    },
  },
  watch: {
    $route() {
      this.selectedHelp = null
    },
  },
  methods: {
    handleClickLi(id) {
      this.$emit("scrollTo", id)
    },
    onHelpClick(item) {
      // if (this.selectedHelp !== null) return
      this.selectedHelp = item

      const param = {
        articleId: this.currentBlogId,
        thumbsupFlag: this.texts.articleDetail.hasHelp.paramMap[item],
      }

      updateThumbsupNum(param)
    },
  },
}
</script>

<style lang="scss" scoped>
.side-catalogue-container {
  width: 16vw;
  box-sizing: border-box;
  user-select: none;
  .help {
    font-size: 15px;
    color: #9e9fa1;
    padding: 24px 0 20px 24px;
    .help-box {
      display: flex;
      gap: 16px;
    }
    .help-item {
      width: 62px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border-radius: 8px;
      background-color: #f6f6f7;
      cursor: pointer;
    }
    .is-active {
      background-color: #0057ff24;
    }
  }
  ul {
    margin: 0;
    padding: 0;
    max-height: 600px;
    overflow-y: auto;
    overflow-x: auto;
    position: relative;
    // padding: 0 10px;
    font-size: 15px;
    .dot {
      border: 3px solid;
      width: 3px;
      height: 3px;
      border-radius: 50%;
      color: #36f;
      position: absolute;
      left: 7px;
      transition: all 0.2s linear 0.3s;
      top: 12px;
    }
    li {
      height: 38px;
      color: #000;
      // border-left: 2px solid #ddd;
      // font-size: 13px;
      margin-bottom: 12px;
      cursor: pointer;
      line-height: 38px;
      list-style: none;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    // li[type="header1"] {
    //   padding-left: 0px;
    // }
    // li[type="header2"] {
    //   padding-left: 12px;
    // }
    li[type="header3"] {
      padding-left: 24px;
    }
    li[type="header4"] {
      padding-left: 56px;
    }
    li.active {
      color: #36f !important;
    }
  }
}
</style>
